import classNames from "classnames"

import { WidgetTag, isInPlaceEditingActive, provideComponent } from "scrivito"
import { LOGIN_OVERLAY } from "shared/context/overlay/types"
import { Alignment } from "shared/lib/layout/Alignment"
import { getAlignmentContainerClassName } from "shared/lib/layout/getAlignmentContainerClassname"
import { useAuth } from "shared/lib/useAuth"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { LoginButtonWidget } from "./LoginButtonWidgetClass"

provideComponent(LoginButtonWidget, ({ widget }) => {
  const { isAuthenticated } = useAuth()
  const { openOverlay } = useOverlay(LOGIN_OVERLAY)

  const handleOpenLoginOverlay = useEvent(() => openOverlay(null))

  if (!isInPlaceEditingActive() && isAuthenticated) {
    return null
  }

  return (
    <WidgetTag
      className={getAlignmentContainerClassName(
        widget.get("alignment") as Alignment
      )}
    >
      <Button
        variant={widget.get("variant") as ButtonVariant}
        onClick={handleOpenLoginOverlay}
        className={classNames({ "opacity-50": isAuthenticated })}
      >
        {widget.get("icon") ? (
          <Icon name={widget.get("icon") as IconName} />
        ) : null}
        {widget.get("text")}
      </Button>
    </WidgetTag>
  )
})
